<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        append-icon="mdi-clock-time-four-outline"
        readonly
        v-model="value"
        @click:clear="clear"
        @click:append="showPicker = true"
        v-bind="$attrs"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="showPicker"
      v-model="timeValue"
      @change="change"
      format="24hr"
      full-width
      :locale="userCultureCode"
    ></v-time-picker>
  </v-menu>
</template>
<script>
export default {
    props: {
        value: {
            type: String,
        },
    },
    data() {
        return {
            showPicker: false,
            userCultureCode: this.$store.getters['account/user'].CultureCode,
            timeValue: null,
        };
    },
    methods: {
        clear() {
            this.timeValue = null;
            this.change();
        },
        change() {
            this.$emit('input', this.timeValue);
            this.$emit('change', this.timeValue);
        },
    },
};
</script>